import React from 'react';
import { useSiteMetadata } from '../../hooks/use-site-metadata';

type SEOProps = {
  title: string;
  description: string;
  pathname: string;
  children: any;
}

export const SEO = ({ title, description, pathname, children }: SEOProps) => {
  const {
    title: defaultTitle,
    description: defaultDescription,
    image,
    siteUrl,
    twitterUsername,
  } = useSiteMetadata();

  const seo = {
    title: title || defaultTitle,
    description: description || defaultDescription,
    image:
      'https://www.svetionikznanja.afirmacijakulture.org/wp-content/uploads/sites/3/sites/3/2024/10/ogimage.webp',
    url: `${siteUrl}${pathname || ``}`,
    twitterUsername,
  };

  return (
    <>
      <title>{seo.title}</title>
      <meta name="description" content={seo.description} />
      <meta name="image" content={seo.image} />
      <meta name="og:image" content={seo.image} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={seo.title} />
      <meta name="twitter:url" content={seo.url} />
      <meta name="twitter:description" content={seo.description} />
      <meta name="twitter:image" content={seo.image} />
      <meta name="twitter:creator" content={seo.twitterUsername} />

      <meta name="facebook:card" content="summary_large_image" />
      <meta name="facebook:title" content={seo.title} />
      <meta name="facebook:url" content={seo.url} />
      <meta name="facebook:description" content={seo.description} />
      <meta name="facebook:image" content={seo.image} />
      <meta name="facebook:creator" content={seo.twitterUsername} />

      <meta property="og:url" content={seo.description} />
      <meta property="og:title" content={seo.title} />
      <meta property="og:description" content={seo.description} />
      <meta property="og:image" content={seo.image} />
      <meta property="og:site_name" content="Svetionik znanja" />

      <link rel="icon" href="src/images/favicon.png" />
      {children}
    </>
  );
};
